import React from 'react'
import { Button, Grid, GridCell, Spacer, Text, View } from 'oio-react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import Footer from 'src/components/Footer'
import Ad from 'src/custom/gns3/Ad'
import HomeCoverVideo from 'src/custom/gns3/Home/CoverVideo'
import { Theme } from 'src/libraries/contexts/Theme'
import { useOrganization } from 'src/graphql/hooks'

const homeAdIds = ['325994', '325997', '435275']

const customers = [{
   name: 'AT&T',
   image: 'att.png'
}, {
   name: 'Google',
   image: 'google.png'
}, {
   name: 'Visa',
   image: 'visa.png'
}, {
   name: 'Starbucks',
   image: 'starbucks.png'
}, {
   name: 'T-Systems',
   image: 'tsystems.png'
}, {
   name: 'NASA',
   image: 'nasa.png'
}]

const HomeLayout = () => {
   const { organization } = useOrganization()
   const memberRole = organization.roles.find(r => r.type === 'primary')
   const softwareVersion = organization.metadata.find(m => m.key === 'software_version')?.value
   const softwareDownloadCount = organization.metadata
      .find(m => m.key === 'software_download_count')?.value

   return (
      <>
         <Helmet title={`${organization.name} | The software that empowers network professionals`} />
         <Theme
            globalNavBackgroundColor="transparent"
            globalNavBorderColor="transparent"
            globalNavDividerColor="#333"
            globalNavTextColor="rgba(255,255,255,0.5)"
         />
         <View
            position="relative"
            width="100%"
            height="720px[a-b] 720px[c-d] 780px[e-f]"
            backgroundColor="#0a1d2d">
            <HomeCoverVideo />
            <View
               display="flex"
               alignItems="center"
               justifyContent="center"
               position="absolute"
               top="0px"
               left="0px"
               width="100%"
               height="100%"
               style={{
                  background: 'linear-gradient(0deg, rgba(4, 13, 28, 0.3), rgba(2, 9, 22, 1))'
               }}>
               <View
                  width="100%"
                  maxWidth="100%[a-b] 80%[c] 720px[d-f]"
                  padding="30px"
                  textAlign="center">
                  <View display="inline-block">
                     <img
                        src="/assets/custom/gns3/images/logo-colour.png"
                        alt="GNS3"
                        width="78px"
                     />
                  </View>
                  <Spacer size="6" />
                  <Text size="8[a] 9[b] 12[c-f]" color="#fff" weight="medium" letterSpacing="-2px">
                     The software that empowers
                     <br />
                     network professionals
                  </Text>
                  <Spacer size="6" />
                  <Text size="3[a-b] 5[c-f]" color="rgba(255,255,255,0.7)">
                     {'Join the world\'s largest community of network professionals who rely on GNS3 to build better networks, share ideas and make connections.'}
                  </Text>
                  <Spacer size="6" />
                  <View
                     width="100%[a]"
                     display="inline-block"
                     marginBottom="6px[a]"
                     marginRight="6px[b-f]">
                     <Button
                        width="100%[a] 180px[b] auto[c-f]"
                        linkTo="/software/download"
                        size="lg[a-b] xl[c-f]"
                        name="Free Download"
                        color="rgb(33, 167, 75)"
                     />
                  </View>
                  <Button
                     linkTo="/software/video"
                     width="100%[a] 180px[b] auto[c-f]"
                     size="lg[a-b] xl[c-f]"
                     name="Watch Video"
                  />
               </View>
            </View>
         </View>
         <View display="flex" justifyContent="center">
            <View
               width="100%"
               maxWidth="90%[a] 100%[b] 780px[c] 1200px[d-f]"
               padding="30px">
               <Grid columns="1[a] 2[b] 2[c] 4[d-f]">
                  <GridCell>
                     <Link to="/software">
                        <View
                           position="relative"
                           width="100%"
                           paddingTop="50%"
                           borderRadius="6px"
                           backgroundImage="url(/assets/custom/gns3/images/home/bg-software-feature.jpg)"
                           backgroundPosition="center center"
                           backgroundSize="cover"
                           boxShadow="3px 3px 12px rgba(0,0,0,0.4)"
                           style={{ overflow: 'hidden' }}>
                           <View
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              position="absolute"
                              top="0px"
                              right="0px"
                              left="0px"
                              bottom="0px"
                              textAlign="center">
                              <View>
                                 <Text size="8[a-b] 10[c-f]" letterSpacing="-1px" weight="bold" color="#fff">
                                    {softwareVersion}
                                 </Text>
                                 <Spacer size="1" />
                                 <Text size="0.9[a-b] 1[c-f]" color="rgba(255,255,255,0.8)" weight="medium">
                                    {`GNS3 ${softwareVersion} is now available`}
                                 </Text>
                                 <Spacer size="0.5" />
                                 <Text size="0.9[a-b] 1[c-f]" weight="medium" color="rgba(255,255,255,0.5)">
                                    Learn More
                                 </Text>
                              </View>
                           </View>
                        </View>
                     </Link>
                  </GridCell>
                  {homeAdIds.map(adId => (
                     <GridCell key={adId}>
                        <View
                           width="100%"
                           borderRadius="6px"
                           boxShadow="3px 3px 12px rgba(0,0,0,0.4)"
                           style={{ overflow: 'hidden' }}>
                           <Ad adId={adId} aspectRatio={0.5} />
                        </View>
                     </GridCell>
                  ))}
               </Grid>
            </View>
         </View>
         <View
            float="left"
            display="none[a] block[b-e]"
            width="100%"
            padding="30px 0px 60px 0px"
            backgroundColor="#15181C"
            textAlign="center">
            <View
               display="block"
               width="100%"
               padding="30px 24px">
               <Text size="4" color="rgba(255,255,255,0.5)" weight="medium">
                  <View display="inline-block" id="mo-download-count">
                     <Text size="4" color="#fff" weight="medium">
                        {softwareDownloadCount}
                     </Text>
                  </View>
                  &nbsp;
                  Downloads from
                  &nbsp;
                  <View display="inline-block" id="mo-community-member-count">
                     <Text size="4" color="#fff" weight="medium">
                        {parseInt(memberRole.numActiveUsers, 10).toLocaleString()}
                     </Text>
                  </View>
                  &nbsp; network professionals worldwide
               </Text>
            </View>
            {customers.map(customer => (
               <View
                  key={customer.name}
                  display="inline-flex"
                  justifyContent="center"
                  alignItems="center"
                  width="150px"
                  height="90px"
                  opacity="0.6">
                  <img
                     src={`/assets/custom/gns3/images/home/${customer.image}`}
                     alt={customer.name}
                     height="42px"
                  />
               </View>
            ))}
         </View>
         <Footer />
      </>
   )
}

export default HomeLayout
